import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@radix-ui/themes";
import registerService from "../service/registerService";

export default function SignupView() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        confirmPassword: "",
        phoneNumber: "",
    });    
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const inputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value,
        });
    };

    const register = async (e: React.FormEvent) => {
        e.preventDefault();
        const { email, password, confirmPassword } = formData;

        if (password !== confirmPassword) {
            setMessage("As senhas não coincidem.");
            return;
        }

        // if (!/^\+\d{1,15}$/.test(phoneNumber)) {
        //     setMessage("Formato de telefone inválido. Use o formato como neste exemplo: +5541987654321.");
        //     return;
        // }

        setLoading(true);
        setMessage("");

        try {
            await registerService.registerUser(email, password, email, "+5541999999999");
            navigate("/confirmSignup", { state: { email } });
        } catch (error) {
            setMessage(`Erro ao registrar: ${error}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center">
            <Card className="w-96 p-8 bg-white shadow-lg rounded-lg">
                <h1 className="text-3xl font-semibold text-[#2294ae] text-center mb-6">Registrar</h1>

                {message && (
                    <p className={`text-center mb-4 ${message.includes("sucesso") ? "text-green-500" : "text-red-500"}`}>
                        {message}
                    </p>
                )}

                <form onSubmit={register}>
                    <div className="mb-4">
                        <label htmlFor="email" className="block text-lg font-medium text-[#2294ae] mb-2">Email</label>
                        <input type="email" id="email" value={formData.email} onChange={inputChange} className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]" placeholder="Digite seu email" required />
                    </div>

                    <div className="mb-4">
                        <label htmlFor="password" className="block text-lg font-medium text-[#2294ae] mb-2">Senha</label>
                        <input type="password" id="password" value={formData.password} onChange={inputChange} className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]" placeholder="Crie uma senha" required />
                    </div>

                    <div className="mb-6">
                        <label htmlFor="confirmPassword" className="block text-lg font-medium text-[#2294ae] mb-2">Confirmar Senha</label>
                        <input type="password" id="confirmPassword" value={formData.confirmPassword} onChange={inputChange} className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]" placeholder="Repita a senha" required />
                    </div>

                    {/* <div className="mb-4">
                        <label htmlFor="phoneNumber" className="block text-lg font-medium text-[#2294ae] mb-2">Telefone</label>
                        <input type="text" id="phoneNumber" value={formData.phoneNumber} onChange={inputChange} className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]" placeholder="Ex: +5541987654321" required />
                    </div> */}

                    <button type="submit" className="w-full py-2 bg-[#2294ae] text-white font-bold rounded-md hover:bg-[#1c7c92] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2294ae]" disabled={loading}>
                        {loading ? "Registrando..." : "Registrar-se"}
                    </button>
                </form>

                <p className="text-center text-gray-600 mt-4">
                    Já tem uma conta? <a href="/login" className="text-[#2294ae] hover:underline">Faça login</a>
                </p>
            </Card>
        </div>
    );
}